import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import EQuoteTermsModal from '../EQuoteTermsModal/EQuoteTermsModal'

import '../../styles/scss/components/equote-footer.scss'
import { getBrandClassName } from '../../reducers/packageDetails'
import { getActivePackageData } from '../../reducers/activePackage'
import TradeMark from '../tradeMark/TradeMark'

class EQuotePreviewPackageFooter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      modalTitle: null,
      modalContent: null
    }
  }

  handleOpenModal = () => {
    const { privacyPolicy, brandLabel } = this.props

    this.setState({
      modalIsOpen: true,
      modalTitle:
        privacyPolicy &&
        privacyPolicy['privacy-policy'] &&
        privacyPolicy['privacy-policy'].title
          ? privacyPolicy['privacy-policy'].title
          : null,
      modalContent:
        privacyPolicy &&
        privacyPolicy['privacy-policy'] &&
        privacyPolicy['privacy-policy'][
          `${this.renderPrivacyPolicy(brandLabel)}`
        ]
          ? privacyPolicy['privacy-policy'][
              `${this.renderPrivacyPolicy(brandLabel)}`
            ]
          : privacyPolicy['privacy-policy']['content']
    })
  }

  renderPrivacyPolicy = brandLabel => {
    if (!brandLabel) {
      return 'content'
    }
    switch (brandLabel.brand) {
      case 'C':
        return 'policy_c'
      case 'R':
        return 'policy_r'
      case 'Z':
        return 'policy_z'
      default:
        return 'content'
    }
  }

  render() {
    const { brandClassName, privacyPolicy } = this.props

    return (
      <div className="equote__footer">
        <div className="equote__footer-container u-content-container">
          <div className="equote__footer-rights">
            <TradeMark />
          </div>

          <p className="equote__footer-links">
            {privacyPolicy && (
              <button
                className="equote__footer-link btn btn-text"
                onClick={this.handleOpenModal}
              >
                Privacy Policy
              </button>
            )}
          </p>
        </div>
        <EQuoteTermsModal
          isOpen={this.state.modalIsOpen}
          onRequestClose={() => this.setState({ modalIsOpen: false })}
          title={this.state.modalTitle}
          content={this.state.modalContent}
          brandClassName={brandClassName}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const activePackage = getActivePackageData(state)
  return {
    privacyPolicy: state.labelsData.labels,
    brandLabel: activePackage && activePackage.brand,
    brandClassName: getBrandClassName(state)
  }
}

export default connect(mapStateToProps)(EQuotePreviewPackageFooter)
